export const DEFAULT_MIN_WIDTH = 300;
export const DEFAULT_MAX_WIDTH = 800;
